import { render, staticRenderFns } from "./HelloPages.vue?vue&type=template&id=72ca4886&scoped=true&"
import script from "./HelloPages.vue?vue&type=script&lang=js&"
export * from "./HelloPages.vue?vue&type=script&lang=js&"
import style0 from "./HelloPages.vue?vue&type=style&index=0&id=72ca4886&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca4886",
  null
  
)

export default component.exports